import { LocalNotifications } from "@capacitor/local-notifications"
import { useGlobalToast } from "~/composables/states"
import { formatDate, toggleAskNotificationPermissions } from "~/utilities/helpers"
import { idToNumber } from "~/composables/data/basePages"
//import { Capacitor } from "@capacitor/core"

// assembles the proper title for the schedule entry
export const getEntryTitle = (entry) => {
    return entry.attributes.parentTitle && entry.attributes.scheduleEventTitle
        ? `${entry.attributes.parentTitle}: ${entry.attributes.scheduleEventTitle}`
        : entry.attributes.scheduleEventTitle ?? entry.attributes.parentTitle
}

// local notifications list state
export const usePendingLocalNotifications = () => useState('usePendingLocalNotifications', () => null)

// update the global state
export const setPendingLocalNotifications = async () => {
    const pendingLocalNotifications = usePendingLocalNotifications()
    await nextTick()
    pendingLocalNotifications.value = await LocalNotifications.getPending()
}

// check if the entry is in the local notifications list
export const checkNotificationsList = (entry) => {
    const pendingLocalNotifications = usePendingLocalNotifications()
    return pendingLocalNotifications.value?.notifications.some(
        (notification) => notification.extra.id === entry.id
    ) || false
}

// Legacy "ShowSchedule:<n>" ids use the numeric part; UUID ids are hashed to a safe integer.
export const getNotificationId = (id) => {
    const legacyId = String(id).split(":")[1]
    return legacyId && Number.isInteger(Number(legacyId))
        ? Number(legacyId)
        : idToNumber(id)
}

// schedule a local notification
export const scheduleLocalNotification = async (entry) => {
    const id = getNotificationId(entry.id)
    const globalToast = useGlobalToast()

    const entryStartDate = await new Date(entry.attributes.start)
    //const entryStartDateInFiveSeconds = new Date(Date.now() + 5000)
    const title = `${getEntryTitle(entry)} is starting now on ${entry.station}!`

    const body = entry.attributes.scheduleEventTitle ? `${entry.attributes.scheduleEventTitle}` : ''
    const serializedEntry = JSON.stringify(entry)
    const parsedEntry = JSON.parse(serializedEntry)

    const notificationBody = {
        notifications: [
            {
                title,
                body,
                id,
                schedule: { at: /* entryStartDateInFiveSeconds */entryStartDate, allowWhileIdle: true },
                //schedule: { at: new Date(Date.now() + 5000) },
                sound: "notification.wav",
                actionTypeId: "route-live",
                extra: parsedEntry,
            },
        ],
    }
    const permitted = await LocalNotifications.checkPermissions()
    if (permitted.display === "granted") {
        if (!checkNotificationsList(entry)) {
            await LocalNotifications.schedule(notificationBody)
            setPendingLocalNotifications()
            globalToast.value = {
                severity: "success",
                summary: `Notification set for ${formatDate(
                    entry.attributes.start,
                    "h:mm a EEE, MMM do "
                )}`,
                life: 3000,
                closable: true,
            }

        } else {
            await LocalNotifications.cancel(notificationBody)
            setPendingLocalNotifications()
        }
    } else {
        // ask permissions
        if (permitted.display === "prompt") {
            await LocalNotifications.requestPermissions()
        } else {
            await toggleAskNotificationPermissions()
        }
    }
}

// initialize local notifications and add listener to handle when tapping on a notification and what the app should do
export const initLocalNotifications = async () => {
    setPendingLocalNotifications()
    // Method called when tapping on a push notification
    await LocalNotifications.addListener(
        "localNotificationActionPerformed",
        (data) => {

            // we use the slug in the notification data to create the query variable
            window.location.href = `/live?slug=${data.notification.extra.slug}&autoplay=true`
        }
    )
}

// cancel all pending notifications if they exist and alert the user
export const cancelAllPendingLocalNotifications = async (pendingLocalNotifications) => {
    try {
        const idsArray = pendingLocalNotifications.notifications.map(notification => ({ id: notification.id }))
        await LocalNotifications.cancel({ notifications: idsArray })

        setPendingLocalNotifications()
    } catch (error) {
        console.error('Error cancelling notifications:', error)
    }
}